module.exports = __webpack_public_path__ + "img/axis.a7c81707.svg";